'use strict';

const isMobile = () => {
    const mobileAgentHash = ['mobile', 'tablet', 'phone', 'ipad', 'ipod', 'android', 'blackberry', 'windows ce', 'opera mini', 'palm'];
    let idx = 0;
    let isMobile = false;

    // Removing the 'tablet pc 2.0' since this triggers a false positive on laptops with IE11 and a touch screen
    const userAgent = (navigator.userAgent).toLowerCase().replace('tablet pc 2.0; ', '');

    while (mobileAgentHash[idx] && !isMobile) {
        isMobile = (userAgent.indexOf(mobileAgentHash[idx]) >= 0);
        idx++;
    }
    return isMobile;
};

module.exports = isMobile;
